import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import clsx from 'clsx';
import Tag from '../atoms/Tag';
import { randomInt } from '../../lib/utils';
import styles from '../../styles/components/molecules/Tags.module.scss';

interface TagsProps {
  data: {
    label: string;
    dark?: boolean;
  }[];
}

export default function Ratings(props: TagsProps) {
  const { data } = props;
  const { tags } = styles;
  const classes = clsx(tags);

  return (
    <ul className={classes}>
      {data.map((el, i) => (
        <li key={i}>
          <Tag label={el.label} dark={el.dark} />
        </li>
      ))}
    </ul>
  );
}
